import { v4 as uuidv4 } from "uuid";
import { useListenFromRenderer } from "../message";
import { postToRenderer } from "../message/utils";
import { fetchInferenceJob } from "./shared/fetch-inference-job";
import { getTargetEditorImage } from "./shared/target-editor-image";

const TOOL_NAME = "Typography";
const PROMPT_DOCUMENT_ID = "hov9h8ny7z6ynzzi63wtqsr0";

const callTypography = async (
	messageId: string,
	jwt: string,
	text: string,
	refImg: string,
	resolution: string,
	backgroundRemover: boolean,
	tool_document_id: string,
) => {
	const { success } = await getTargetEditorImage({
		commandName: TOOL_NAME,
		resultLayerName: TOOL_NAME,
		preventSmartObjectTrim: backgroundRemover,
		processImage: async ({ executionContext, selBounds }) => {
			const refImgBase64 = refImg.startsWith("data:image/")
				? refImg.split(",")[1]
				: refImg;
			const data = {
				prompt_document_id: PROMPT_DOCUMENT_ID,
				prompt_index: 0,
				prompt_variables: {
					editor_width: String(selBounds.width),
					editor_height: String(selBounds.height),
					text,
				},
				input_images: [refImgBase64],
				resolution,
				from_editor: false,
				batch_size: 1,
				background_remover: backgroundRemover,
				editor_width: selBounds.width,
				editor_height: selBounds.height,
				jwt,
				tool_document_id,
			};
			return fetchTypography(data, executionContext, messageId);
		},
	});
	return success;
};

export async function fetchTypography(
	params: {
		prompt_document_id: string;
		prompt_index: number;
		prompt_variables: {
			editor_width: string;
			editor_height: string;
			text: string;
		};
		input_images: string[];
		resolution: string;
		from_editor: boolean;
		batch_size: number;
		background_remover: boolean;
		editor_width: number;
		editor_height: number;
		jwt: string;
		tool_document_id: string;
	},
	executionContext: any,
	messageId: string,
): Promise<string | string[] | false> {
	return fetchInferenceJob({
		params,
		executionContext,
		messageId,
		apiPath: "/infer/oplux",
		statusEndpoint: (apiUrl, jobId) =>
			`${apiUrl.replace("/infer/oplux", "")}/status/${jobId}`,
		resultEndpoint: (apiUrl, jobId) =>
			`${apiUrl.replace("/infer/oplux", "")}/result/${jobId}`,
		cancelEndpoint: (apiUrl, jobId) => ({
			url: `${apiUrl.replace("/infer/oplux", "")}/cancel/${jobId}`,
			method: "POST",
		}),
		extractResult: (data) => data.image_base64_list ?? [data.image_base64],
		useGatewayUrl: true,
	});
}

export function useListenTypographyMessage() {
	useListenFromRenderer([
		{
			key: "typography",
			onMessage: async (message) => {
				const success = await callTypography(
					message.id,
					message.values.jwt,
					message.values.text,
					message.values.ref_img,
					message.values.resolution,
					message.values.background_remover,
					message.values.tool_document_id,
				);
				postToRenderer([
					{
						key: "finish",
						id: uuidv4(),
						values: {
							id: message.id,
							status: success ? "success" : "error",
						},
					},
				]);
			},
		},
	]);
}
